import { PageMeta } from "src/components";
import { appConfig } from "src/config";
import { LEGAL_DOCUMENTS } from "src/constants/constants";
import { useTranslate } from "src/i18n";
import { DocumentViewer } from "src/widgets/DocumentViewer/DocumentViewer";

export const PrivacyPage = () => {
  const { t } = useTranslate();

  const title = t("privacy.title", "Политика конфиденциальности");
  const pageTitle = `${title} — ${appConfig.displayName}`;
  const description = t(
    "privacy.meta.description",
    "Политика конфиденциальности сервиса {displayName}. Обработка и защита персональных данных.",
    { displayName: appConfig.displayName },
  );

  return (
    <>
      <PageMeta title={pageTitle} description={description} path="/privacy" />
      <DocumentViewer
        title={title}
        pdfUrl={LEGAL_DOCUMENTS.PRIVACY_POLICY}
        documentTitle={title}
      />
    </>
  );
};
